class CartFooter extends HTMLElement {
    constructor() {
        super();
    }

    addProperties() {
        this.privacyInfo = this.querySelector('[data-privacy-info]');
        this.checkoutBtn = this.querySelector('button[name="checkout"]');
    }
    connectedCallback() {
        this.addProperties()
        if (!this.privacyInfo) return;
        this.handleCheckout(this.privacyInfo.checked)
        this.addListeners()
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
            this.addProperties.bind(this)()
            this.addListeners.bind(this)()
        } )
    }

    addListeners() {
        this.privacyInfo.addEventListener('change', (event) => this.handleCheckout.bind(this, event.target.checked)())
    }

    handleCheckout(value) {
       this.checkoutBtn.toggleAttribute('disabled', !value)
    }
}

customElements.define('cart-footer', CartFooter);
